export const calculateDelta = (
  currentValue: number | undefined,
  previousValue: number | undefined,
) => {
  return currentValue === undefined || !previousValue
    ? undefined
    : (currentValue - previousValue) / previousValue;
};
